module.exports = (parcelRequire.load("h7GDc")).then(() => parcelRequire('3BxGV'));